// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPeoplePersonOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 6c-1.109 0-2 .891-2 2s.891 2 2 2 2-.891 2-2-.891-2-2-2zm4 2c0 2.213-1.787 4-4 4s-4-1.787-4-4 1.787-4 4-4 4 1.787 4 4zM6 18h12v-.22c0-.604-.508-1.298-1.797-1.898C14.978 15.312 13.375 15 12 15c-1.375 0-2.978.312-4.203.882C6.508 16.482 6 17.176 6 17.78zm11.047-3.93c1.461.68 2.953 1.876 2.953 3.71V20H4v-2.22c0-1.834 1.492-3.03 2.953-3.71C8.478 13.358 10.375 13 12 13c1.625 0 3.522.359 5.047 1.07z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPeoplePersonOutlined;
